import { TextField, Typography } from "@mui/material";



export const CustomTextField = ({
    name,
    label,
    type,
    register,
    errors,
    disabled,
    required,
    multiline = false,  // default to false
    rows = 1            // default to 1 row
}) => (
    <div>

        <TextField
            type={type}
            label={
                <Typography variant="h6" fontWeight="bold" color={"text.dark"}>
                    {label} {required && <span style={{ color: "red" }}>*</span>}
                </Typography>
            }
            {...register(name)}
            InputLabelProps={type === "date" ? { shrink: true } : {}}
            error={!!errors[name]}
            helperText={errors[name]?.message}
            fullWidth
            margin="normal"
            variant="outlined"
            disabled={disabled}
            multiline={multiline}
            rows={rows}
        />
    </div>
);



